<template>
    <div class="warp">
        <div class="echarts" ref="echarts" style="width:100%;height:350px"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['coreData'],
    data() {
        return {
            paymentamountYdata: [5, 7, 8, 10, 15, 19, 17, 18, 14, 12, 6, 5],
            visitclientYdata: [3, 5, 6, 9, 12, 16, 15, 11, 8, 5, 3, 1],
            orderpayYdata: [7, 9, 11, 16, 21, 19, 20, 16, 14, 5, 9, 11],
            conentViewYdata: [1, 2, 3, 4, 5, 6, 7, 6, 5, 4, 2, 1],
            xdata: []
        }
    },
    watch: {
        coreData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.coreData)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(datas) {
            this.paymentamountYdata = datas.paymentamountYdata
            this.visitclientYdata = datas.visitclientYdata
            this.orderpayYdata = datas.orderpayYdata
            this.conentViewYdata = datas.conentViewYdata
            this.xdata = datas.xdata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            return {
                color: ['#1989FA', '#E6A23C', '#67C23A', '#F56C6C'],
                title: {
                    subtext: '指标趋势',
                    left: 'left',
                    subtextStyle: {
                        color: '#606266'
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['付款金额', '访客数', '支付订单数', '浏览量'],
                    icon: 'circle',
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10 // 设置高度
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    // data: ['2019-04-01', '2019-04-02', '2019-04-03', '2019-04-04', '2019-04-05', '2019-04-06', '2019-04-07', '2019-04-08', '2019-04-09', '2019-04-10', '2019-04-11', '2019-04-12']
                    data: this.xdata
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    // nameTextStyle: {
                    //     color: 'red'
                    // },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#f2f2f2'],
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '付款金额',
                        type: 'line',
                        data: this.paymentamountYdata
                    },
                    {
                        name: '访客数',
                        type: 'line',
                        data: this.visitclientYdata
                    },
                    {
                        name: '支付订单数',
                        type: 'line',
                        data: this.orderpayYdata
                    },
                    {
                        name: '浏览量',
                        type: 'line',
                        data: this.conentViewYdata
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>